<template>
  <div>
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="iccid">
        <el-input v-model="queryParams.iccid" placeholder="ICCID"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item prop="operator">
        <el-input v-model="queryParams.operator" placeholder="申请人"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-top: 10px">
        <el-table :data="tableData" border>
          <el-table-column prop="iccid" label="ICCID" align="center">
            <template slot-scope="scope">
              <div style="color: #4466AD;cursor: pointer;text-decoration: underline;" class="complaint-class" @click="jumpCardDetails(scope.row.iccid)">{{ scope.row.iccid }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNum" label="订单号" align="center"></el-table-column>
          <el-table-column prop="productName" label="套餐名" align="center"></el-table-column>
          <el-table-column prop="operator" label="申请人" align="center"></el-table-column>
          <el-table-column prop="createTime" label="提交时间" align="center"></el-table-column>
        </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { cardProductRecordList , cardExist} from "@/api/api.js"; //套餐作废列表
export default {
  data() {
    return{
      queryParams:{
        iccid:undefined,
        operator:undefined
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      an:false,
      dateRange:[],
      // 申请退款
      ruleForm:{},
    }
  },
  methods: {
    jumpCardDetails(iccid){
      let params = {
        number:iccid,
        type:"1"
      }
      cardExist(params).then(res=>{
        let card = res.data.data;
        //直接跳转  国际卡判断
        if(card.operationName == '国际'){
            this.$router.push({path:"/international/internationalDetail",query:{iccid: card.iccid}});
        }else if(card.operationName == '多网'){
          this.$router.push({path:"/card/multiNet/info",query:{groupNo: card.iccid}});
        }else{
          this.$router.push({path:"/card/detail",query:{iccid: card.iccid}});
        }
      })
    },
    // 获取列表的数据
    initData(){
      let params = {
        model:{
					... this.addDateRange(this.queryParams, this.dateRange),
				},
        page: this.page,
        pageSize: this.pageSize,
      };
      params.model.type = "3";
      cardProductRecordList(params).then(res=>{
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        }
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.initData();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
  },
  mounted() {
    this.initData();
  },
  created() {
    
  }
};
</script>
<style scoped lang="less">

</style>


